<template>
	<FullPageLoader />
	<HeaderTestSiteWarning />
	<HeaderSiteNotification />

	<div id="bg-fixed"></div>
	<HeaderBasicHeader />

	<!-- Page content -->
	<slot />

	<FooterBasicFooter />
</template>

<script setup>
	import FullPageLoader from "~/components/fullPageLoader.vue"

	const runtimeConfig = useRuntimeConfig()

	useHead(() => {
		//Prefix all page titles with the event name
		return {
			titleTemplate: (pageTitle) => {
				return pageTitle ? `${runtimeConfig.public.EVENT_NAME} - ${pageTitle}` : `${runtimeConfig.public.EVENT_NAME}`
			},
		}
	})
</script>

<style scoped></style>
